<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="6">
        <Progress :result="result" :products="products" />
      </v-col>
      <v-col cols="12" sm="6">
        <ChartLine :obj="obj" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ChartLine from "./Detailes_charts";
import Progress from "./Detaile_progress";

export default {
  name: "ProductDetails",
  components: {
    ChartLine,
    Progress,
  },
  data: () => ({
    obj: [],
  }),
  props: {
    result: null,
    products: null,
  },
  created() {
    console.log("created", this.result);
    this.result.input_img_rgb.rgb.forEach((element) => {
      const val = (
        100 * Math.abs(element[1] / this.result.input_img_rgb.pixel_cmp)
      ).toFixed(2);
      this.obj.push({ color: element[0], val: val });
    });
  },
  mounted() {
    if (this.obj.length) {
      console.log("mounted", this.result);
      this.result.input_img_rgb.rgb.forEach((element) => {
        const val = (
          100 * Math.abs(element[1] / this.result.input_img_rgb.pixel_cmp)
        ).toFixed(2);
        this.obj.push({ color: element[0], val: val });
      });
    }
  },
  methods: {},
};
</script>
